import styles from './SignInRegisterLink.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { stringify } from 'query-string';

import { signInRegUrlPrefix } from 'config';
import ExternalLink from 'ExternalLink/ExternalLink';

const MODES = {
  signin: {
    label: 'Sign In',
    href: `${signInRegUrlPrefix}/Login/Standalone`,
    analyticsTag: 'sign-in'
  },
  register: {
    label: 'Register',
    href: `${signInRegUrlPrefix}/Register/Standalone`,
    analyticsTag: 'register'
  }
};

const getUrl = (linkUrl, returnUrl) => (
  `${linkUrl}?returnUrl=${encodeURIComponent(returnUrl)}`
);

@connect(({ location }) => ({
  path: location.pathname,
  query: location.query
}))
export default class SignInRegisterLink extends Component {

  static propTypes = {
    children: PropTypes.node,
    path: PropTypes.string.isRequired,
    query: PropTypes.object.isRequired,
    params: PropTypes.object,
    mode: PropTypes.oneOf(Object.keys(MODES)).isRequired
  };

  static defaultProps = {
    params: {}
  };

  constructor(props) {
    super(props);

    this.mode = MODES[props.mode];
  }

  render() {
    const { children, path, query, params, ...props } = this.props;
    const { label, href, analyticsTag } = this.mode;
    const queryString = stringify({ ...query, ...params });
    const returnUrl = `${path}${queryString ? `?${queryString}` : ''}`;

    return (
      <ExternalLink
        analytics={analyticsTag}
        title={label}
        href={getUrl(href, returnUrl)}
        className={styles.root}
        {...props}>
        {children}
      </ExternalLink>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SignInRegisterLink/SignInRegisterLink.js
 **/